module.exports = __webpack_public_path__ + "img/banner2.0f24d5e6.jpg";